import { shape, string } from 'prop-types';

export default shape({
    buttonText: string.isRequired,
    text: string.isRequired,
    type: string.isRequired,
    url: string.isRequired,
});
